export default "__VITE_ASSET__22eefcdb__"